import { createFetchClientHttpError } from '@/lib/openapi-fetch/httpError';
import { extractErrorMessage } from '@/utils/extractErrorMessage';

export const errorMiddleware = {
  async onResponse({ response }: { response: Response }) {
    if (response.ok) {
      return response;
    }

    let errorMessage: string;
    let problemType: string | undefined;
    try {
      const errorData = await response.json();
      errorMessage = extractErrorMessage(errorData);
      problemType =
        typeof errorData?.type === 'string' ? errorData.type : undefined;
    } catch {
      // If we can't parse the response body, fall back to a generic error
      errorMessage = '';
    }

    // Throw outside the try so the parsed message can't be swallowed by the
    // catch above. Fall back to the status line only when we have no detail.
    if (!errorMessage) {
      errorMessage = `HTTP ${response.status}: ${response.statusText}`;
    }

    // The API sends whole seconds; the header must be CORS-exposed to be readable.
    const retryAfter = Number(response.headers.get('Retry-After'));

    throw createFetchClientHttpError(
      errorMessage,
      response.status,
      problemType,
      retryAfter > 0 ? retryAfter : undefined,
    );
  },
};
